import { zMoodysRating, zSPRating } from "@goodfill/domain-properties-zod-validators";
import { z } from "zod";

export const zBondRatings = z
  .object({
    moodys: z.union([z.null(), zMoodysRating]),
    sp: z.union([z.null(), zSPRating]),
  })
  .refine((val) => val.moodys !== null || val.sp !== null, { message: "At least one rating must be present" });
